import { createStore, createHook, createActionsHook, createContainer } from 'react-sweet-state';
import type { ConversationProvider } from '../../services/conversation-service/types';
import { addVirtualAgentMessage, setVirtualAgentLoading, setConversationId } from './actions';
import type { State } from './types';

const initialState: State = {
    conversationProvider: {
        sendMessage: () => Promise.resolve([]),
        startConversation: () => Promise.resolve({ conversationId: '', id: '', timeCreated: '' }),
    },
};

const store = createStore({
    initialState,
    name: 'VirtualAgentConversation',
    actions: {
        addVirtualAgentMessage,
        setVirtualAgentLoading,
        setConversationId,
    },
});

export const VirtualAgentConversationStateContainer = createContainer(store, {
    onInit:
        () =>
        (
            { setState },
            {
                conversationProvider,
            }: {
                conversationProvider: ConversationProvider;
            }
        ) => {
            setState({
                conversationProvider,
            });
        },
});

export const useConversationProvider = createHook(store, {
    selector: (state) => state.conversationProvider,
});

export const useVirtualAgentMessages = createHook(store, {
    selector: (state) => state.messages,
});

export const useConversationId = createHook(store, {
    selector: (state) => state.conversationId,
});

export const useActions = createActionsHook(store);
